import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Loader, Alert } from 'rsuite';

// redux
import { getCurrentLinkData, fetchCampaignTerms, resetCurrentLinkData } from '../../redux/modules/campaignLandingPage';
// styles
import styles from './CurrentLinkModal.module.less';

const CurrentLinkModal = ({ _fetchCampaignTerms, _resetCurrentLinkData, currentLinkData }) => {
  const link = currentLinkData?.link;
  const showModal = currentLinkData?.data?.type === 'INLINE';

  useEffect(() => {
    if (link) {
      _fetchCampaignTerms(currentLinkData?.link)
    }
  }, [link]);

  useEffect(() => {
    if (currentLinkData?.error && showModal) {
      Alert.error('Error loading modal content', 5000)
    }
  }, [currentLinkData?.error]);

  const onHide = () => {
    _resetCurrentLinkData();
  }

  const createMarkup = () => {
    return {__html: currentLinkData?.data?.content};
  }

  return (
    <Modal show={showModal} onHide={onHide} size='md'>
      <Modal.Body>
        {currentLinkData?.isLoading ? (
          <div className={styles.vpCurrentLinkLoader}><Loader /></div>
          ) : (
          <section dangerouslySetInnerHTML={createMarkup()} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <section className={styles.vpCurrentLinkModalFooter}>
          <Button appearance="primary" onClick={onHide}>Close</Button>
        </section>
      </Modal.Footer>
    </Modal>
  )
};

const mapStateToProps = (state) => ({
  currentLinkData: getCurrentLinkData(state),
});

const mapDispatchToProps = {
  _fetchCampaignTerms: fetchCampaignTerms,
  _resetCurrentLinkData: resetCurrentLinkData,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentLinkModal);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/CurrentLinkModal.jsx